import { PageType, PageTypes } from 'strapi/page/types';
import { RequestParams } from 'strapi/types';

export const breadcrumbsParams: (
  type: PageType
) => RequestParams<PageTypes> = () => ({});
